module.exports = __webpack_public_path__ + "img/golog_b2bpro.33b8f4ca.png";